
















import { FaturamentoDiario } from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import Component from "vue-class-component";
import { Mixins, Prop } from "vue-property-decorator";

import ChartLine from "@/shared/components/chart-line.vue";
import { title, ticks } from '@/shared/utils/chart';
import { moeda } from "@/shared/filters";

@Component({ components: { ChartLine } })
export default class GraficoFaturamentoDiario extends Mixins(GlobalMixin) {
  //Configurações extras para o chartJs (Opcional)
  readonly options: Chart.ChartOptions | Chart.ChartLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: "index",
      callbacks: {
        //Callback para montar o titulo do tooltip
        title: title(),
        //Configurar label do tooltip retornar o texto customizado
        //Com esta configuração deve retornar ex.: "Total: R$ 20,00"
        //Ao invés de: "Total: 20"
        label: (i, data) => {
          return (
            (data.datasets ?? [])[i.datasetIndex ?? 0].label +
            ": " +
            moeda(+(i.value ?? "0"))
          );
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            //Callback que monta o valor a ser mostrado no eixo x
            callback: ticks(),
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            //Começar gráfico a partir do zero, sem valores negativos
            beginAtZero: true,
            //Função que retorna o valor a ser mostrado no eixo y
            //Inplementada para mascarar o valor numério para o formato moeda
            callback: moeda,
          },
        },
      ],
    },
  };

  @Prop({ default: false }) readonly loading!: boolean;
  @Prop() readonly value!: FaturamentoDiario[];

  //computed
  get labels(): string[] | undefined {
    return this.value?.map((x) => x.data);
  }

  get dataSet(): Chart.ChartDataSets[] | undefined {
    return [
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Valor",
        backgroundColor: "#3e95cd",
        data: (this.value ?? []).map((x) => x.total),
      },
      {
        //Para que não tenha curvas nas linhas entre os pontos
        lineTension: 0,
        label: "Mês Passado",
        backgroundColor: "#cecece",
        data: (this.value ?? []).map((x) => x.totalMesPassado),
      },
    ];
  }
}
